import React, {Component} from 'react';
import CommunityPage from './CommunityPage';
import {Tabs} from '../widgets';
import {connect} from 'react-redux';
import {getSessionUserMembership} from './community.selectors';
import {B2ME_COMM_UUID, DEV_WOODWALE_BAPTIS_COMM} from './index';
import {COUPON_STREAM_WHITELISTED_USERS} from '../betaFeatureWhiteList';

class CommunityTabs extends CommunityPage {
	constructor(props) {
		super(props);
	}

	render() {
		const {sessionProvider} = this.props;
		const {uniqueName} = this.props.match.params;

		const isAdmin = sessionProvider && sessionProvider.user && sessionProvider.user.admin;
		const noticesEnabled = this.props.community && this.props.community.noticesEnabled;
		const sessionUserMembership = getSessionUserMembership(this.props);
		const pendingCount = this.props.community && this.props.community.pendingCount;
		const showMembers = this.props.community && this.props.community.uuid !== B2ME_COMM_UUID;
		/* const showCoupons =
			this.props.community &&
			(this.props.community.uuid === B2ME_COMM_UUID ||
				this.props.community.uuid === DEV_WOODWALE_BAPTIS_COMM) &&
			sessionProvider &&
			sessionProvider.user &&
			COUPON_STREAM_WHITELISTED_USERS.includes(sessionProvider.user.uuid); */

		const showCoupons = true;

		return (
			<Tabs
				items={[
					isAdmin || (sessionUserMembership && sessionUserMembership.admin)
						? {
								link: '/admin/' + uniqueName,
								icon: 'icon-settings',
								label: 'Admin'
						  }
						: undefined,
					{
						link: '/about/' + uniqueName,
						icon: 'icon-public',
						label: 'About'
					},
					showMembers
						? {
								link: '/members/' + uniqueName,
								icon: 'icon-people_outline',
								label: 'Members',
								badgeCount: pendingCount
						  }
						: undefined,
					noticesEnabled && {
						link: '/!' + uniqueName,
						icon: 'icon-dashboard',
						label: 'Noticeboard'
					},
					showCoupons
						? {
								link: '/coupons/' + uniqueName,
								icon: 'icon-loyalty',
								label: 'Promotions'
						  }
						: undefined
				]}
			/>
		);
	}
}

const ConnectedCommunityTabs = connect(
	({community, session}) => ({
		community,
		sessionProvider: session && session.current
	}),
	dispatch => ({})
)(CommunityTabs);

export default ConnectedCommunityTabs;



// WEBPACK FOOTER //
// ./src/community/CommunityTabs.js